import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@mezzodevelopment/mezzo-ui/auth';
import TenantService from '../services/tenantService';
import { Tenant } from '../models/tenant';

export const useCurrentTenant = () => {
  const { tenant } = useAuth();
  const tenantId = (tenant as unknown as { tenantId?: string })?.tenantId;

  return useQuery<Tenant>({
    queryKey: ['current-tenant', tenantId],
    queryFn: () => TenantService.getInstance().get(tenantId!),
    enabled: !!tenantId,
    staleTime: 60_000,
  });
};
